export default [
    {
        path: '/admin/report/daily-item-used-reports',
        name: 'daily-item-used-report',
        meta: { requiresAuth: true },
        component: () => import('@/pages/report/project-mgt/daily-item-used.vue')
    },
    {
        path: '/admin/report/daily-task-updates',
        name: 'daily-task-update',
        meta: { requiresAuth: true },
        component: () => import('@/pages/report/project-mgt/daily-task-update.vue')
    }
]